import * as React from 'react'
import { InputText } from '../../atoms/input-text/input-text'
import { Button } from '../../atoms/button/button'
import { Context } from '../../../context/app-context'
import { V_PASSWORD } from '../../../constants/react-hook-form-validations'
import {
  NUMBER_PATTERN,
  EMAIL_PATTERN,
} from '../../../constants/activity-constants'
import UserSession from '../../../shared-campaign/utils/class/UserSession'
import * as reCaptchaKey from '../../../shared/constants/reCaptcha'
import ReCAPTCHA from 'react-google-recaptcha'
import { useForm } from 'react-hook-form'
import './form-login-college.scss'
import { siteUrl } from '../../../shared/utils/siteUrl'
import useUrlIdRegister from '../../../utils/useUrlIdRegister'

export const FormLoginCollege = ({ handleNextStep }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const recaptchaRef = React.useRef(null)
  const { dispatch } = React.useContext(Context)

  const urlRegister = useUrlIdRegister()
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm()

  const validateEmail = value => {
    if (
      value?.length > 3 &&
      !NUMBER_PATTERN.test(value) &&
      !EMAIL_PATTERN.test(value)
    ) {
      return 'Debes ingresar un correo válido'
    }
  }

  const validateCellPhone = value => {
    let maxDigits = process.env.MAX_DIGITS || '10'

    if (
      value?.length > 3 &&
      NUMBER_PATTERN.test(value) &&
      !EMAIL_PATTERN.test(value) &&
      value.length !== parseInt(maxDigits)
    ) {
      return `El celular debe tener ${maxDigits} dígitos`
    }

    return true
  }

  const setGeneralError = (error = 'Ha ocurrido una exepción inesperada') => {
    setError('password', {
      type: 'customError',
      message: error,
    })
  }

  const onSubmit = ({ username, password }) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interacciones - Formulario Inicio Sesión',
      category: 'cole challenge',
      action: 'click',
      label: 'sesion',
    })
    if (isLoading) return
    setIsLoading(true)

    let maxDigits = process.env.MAX_DIGITS || '10'
    const isCellphone =
      NUMBER_PATTERN.test(username) && username.length === parseInt(maxDigits)

    let usernameFormated = isCellphone
      ? process.env.COUNTRY_PHONE_PREFIX + username
      : username.toLocaleLowerCase()

    let payload = {
      email: usernameFormated,
      password,
      captcha: recaptchaRef.current.getValue(),
    }

    UserSession.userAuth(payload)
      .then(res => {
        if (res.status === 200) {
          UserSession.userInfo().then(res => {
            dispatch({
              type: 'set',
              payload: { userInfo: res.data },
            })
            handleNextStep()
          })
        } else {
          setGeneralError(res?.userMessage)
        }
      })
      .catch(() => {
        setGeneralError()
      })
      .finally(() => {
        recaptchaRef?.current?.execute()
        setIsLoading(false)
      })
  }

  React.useEffect(() => {
    recaptchaRef.current.execute()
  }, [recaptchaRef])



  return (
    <div className="f-login-college">
      <form className="f-login-college__body" onSubmit={handleSubmit(onSubmit)}>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={reCaptchaKey.key}
        />

        <h2 className="f-login-college__body__title">
          INICIA SESIÓN CON TU CUENTA
        </h2>

        <div className="f-login-college__body__fields">
          <InputText
            name="username"
            register={register}
            validations={{
              required: 'Este campo es requerido',
              validate: {
                validateEmail,
                validateCellPhone,
              },
            }}
            errors={errors}
            label="CORREO O CELULAR"
            className="f-login-college__body__fields__field"
          />
          <InputText
            name="password"
            validations={V_PASSWORD}
            errors={errors}
            register={register}
            label="CONTRASEÑA"
            type="password"
            autoComplete="off"
            className="f-login-college__body__fields__field"
          />
        </div>

        <a
          href="/login/recuperar/"
          target="_blank"
          className="f-login-college__body__forgot-password"
        >
          ¿OLVIDASTE TU CONTRASEÑA?
        </a>

        <Button
          color="blue"
          type="submit"
          text="INICIAR SESIÓN"
          className="f-login-college__body__button"
          isLoading={isLoading}
        />
      </form>

      <div className="f-login-college__header">
        <h2 className="f-login-college__header__title">
          Y SI <br /> NO ESTÁS REGISTRADA
          <b>¡TRANQUILA!</b>
        </h2>

        <a
          href={siteUrl + urlRegister}
          target="_blank"
          className="f-login-college__header__link"
          onClick={()=>{
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interacciones - Registro',
              category: 'cole challenge',
              action: 'click',
              label: 'registrate aqui',
            })
          }}
        >
          REGÍSTRATE AQUÍ
        </a>
      </div>
    </div>
  )
}
